module.exports = __webpack_public_path__ + "advisor_guia_banner-a792de7f97c0028900416088e874aa61.jpg";